// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignDtaRequest
 */
export interface SignDtaRequest {
    /**
     * 
     * @type {string}
     * @memberof SignDtaRequest
     */
    attestation_version?: string;
    /**
     * 
     * @type {string}
     * @memberof SignDtaRequest
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof SignDtaRequest
     */
    method?: string;
}

/**
 * Check if a given object implements the SignDtaRequest interface.
 */
export function instanceOfSignDtaRequest(value: object): value is SignDtaRequest {
    return true;
}

export function SignDtaRequestFromJSON(json: any): SignDtaRequest {
    return SignDtaRequestFromJSONTyped(json, false);
}

export function SignDtaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignDtaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'attestation_version': json['attestation_version'] == null ? undefined : json['attestation_version'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'method': json['method'] == null ? undefined : json['method'],
    };
}

export function SignDtaRequestToJSON(json: any): SignDtaRequest {
    return SignDtaRequestToJSONTyped(json, false);
}

export function SignDtaRequestToJSONTyped(value?: SignDtaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attestation_version': value['attestation_version'],
        'comment': value['comment'],
        'method': value['method'],
    };
}
